import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authUserStore';
import { UserRole } from '../models/users';
import Dashboard from './Dashboard';

const RoleHomeRedirect: React.FC = () => {
  const currentUser = useAuthStore((state) => state.currentUser);

  if (currentUser?.role === UserRole.CUSTOMER) {
    return <Navigate to="/my-profile" replace />;
  }

  return <Dashboard />;
};

export default RoleHomeRedirect;
